export default function(){
  var self = this;
  self.use_premium_memberships = ko.observable(false);
  self.monthly_cost = ko.observable();
  self.yearly_cost = ko.observable();

  self.initData = function() {
    var settingsData = JSON.parse($('#js-admin-billing-settings-json').val());
    self.use_premium_memberships(settingsData.use_premium_memberships);
    self.monthly_cost(settingsData.monthly_cost);
    self.yearly_cost(settingsData.yearly_cost);
    self.$el = $('#js-admin-billing-settings');
    // console.log(settingsData);
  };

  self.save = function(form) {
    console.log('saving');
    console.log(arguments);
    var data = {
      use_premium_memberships: self.use_premium_memberships(),
      monthly_cost: self.monthly_cost(),
      yearly_cost: self.yearly_cost(),
    };

    var url = form.action;

    var request = new Kadenze.AjaxRequest({
      type: 'post',
      dataAsJSON: false,
      url: url,
      data: data,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.fail(function(data) {
      Kadenze.UIUtil.showNotice(self.$el, data, 3000);
    });
  };

  const __construct = function(that) {
    console.log('constructor called for Admin.Billing.SettingsVM');
    self.initData();
  }(this);
}

